import { combineReducers } from 'redux';
import MedicalRedux from '../MedicalRedux';
import individualMedicalRedux from '../IndividualMedicalRedux';
import loadingReducer from '../loadingReducer';
import DomainReducer from '../DomainRedux';
import partnerSmsConfigReducer from '../PartnerSmsConfigRedux';


const rootReducer = combineReducers({
	DomainReducer: DomainReducer,
	MedicalRedux : MedicalRedux,
	individualMedicalRedux : individualMedicalRedux,
	loading: loadingReducer,
	partnerSmsConfig: partnerSmsConfigReducer
});

export default rootReducer;